import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Icon } from 'semantic-ui-react';
import styled from '@emotion/styled';
import Contact from 'components/clients/Contact';

const ClientInfoModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const Close = styled.button`
  display: flex;
  justify-content: flex-end;
  padding: 15px;
`;
const ActualContent = styled.div`
  padding: 0 35px;
`;
const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #4d4e4d;
  background: #f7f7f9;
  border-radius: 5px;
  height: 73px;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 22px;
`;

interface Client {
  id?: number;
  clientContacts: ClientContact[];
}

interface ClientContact {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  extension: string;
  defaultContact: boolean;
  defaultTaxContinContact: boolean;
  defaultTitleContinContact: boolean;
}

interface PropTypes {
  onClose: (e?: any) => void;
  clientId: number;
  clientName: string;
}

export const ClientInfoModal = (props: PropTypes) => {
  const [ClientInfo, setClientInfo] = useState<Client>();

  useEffect(() => {
    getClient();
  }, [props.clientId]);

  const getClient = async () => {
    await axios.get(`/api/clients/getclient?clientId=${props.clientId}`).then(({ data }) => {
      if (data) {
        setClientInfo(data);
      }
    });
  };

  return (
    <Modal
      open={true}
      style={{ minHeight: 300, width: 640, maxWidth: 'calc(100vw - 32px)' }}
      onClose={props.onClose}
    >
      <ClientInfoModalContent>
        <Close onClick={props.onClose}>
          <Icon name="close" />
        </Close>
        <ActualContent>
          <Title>{props.clientName}</Title>
          <div>
            {ClientInfo?.clientContacts?.map((c, index) => (
              <div key={index}>
                <Contact
                  firstName={c.firstName}
                  lastName={c.lastName}
                  email={c.email}
                  phone={c.phone}
                  ext={c.extension}
                  defaultContact={c.defaultContact}
                  defaultTaxContinContact={c.defaultTaxContinContact}
                  defaultTitleContinContact={c.defaultTitleContinContact}
                  id={c.id}
                  isEditable={false}
                  handleDeleteContact={null}
                  handleEditContact={null}
                  isClientModal={true}
                />
              </div>
            ))}
          </div>
        </ActualContent>
      </ClientInfoModalContent>
    </Modal>
  );
};
